import { Button, Col, Form, Modal, Row, Spin, Tooltip, message, notification } from 'antd';
import React, { useState } from 'react';
import StAddNew from './DSeries/StAddNew';
import { DeleteOutlined, EditOutlined, LoadingOutlined } from '@ant-design/icons';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import { useSelector } from 'react-redux';

const ChartBuilder = () => {
    const dictNames = {
        "add-chart": "ZenChartBuilder_config",
        "upload-json": "ZenFormBuilder_jsonUploader",
        "edit-row": "ZenChartBuilder_rowConfig",
        "edit-chart": "ZenChartBuilder_config"
    };
    const chartTemplate = [
        {
            "img": "A003.png",
            "template": "A003",
            "chartGroup": "ZenChartArsenal",
            "dictName": "Angela1C_SingleRow",
            "typ": "Angela1C"
        },
        {
            "img": "A004.png",
            "template": "A004",
            "chartGroup": "ZenChartArsenal",
            "dictName": "Angela1R_SingleCol",
            "typ": "Angela1R"
        },
        {
            "img": "A005.png",
            "template": "A005",
            "chartGroup": "ZenChartArsenal",
            "dictName": "AngelaIcon1R_SingleCol",
            "typ": "AngelaIcon1R"
        },
        {
            "img": "A006.png",
            "template": "A006",
            "chartGroup": "ZenChartArsenal",
            "dictName": "AngelaIcon1R_SingleColDoubleLine",
            "typ": "AngelaIcon1R"
        },
        {
            "img": "A007.png",
            "template": "A007",
            "chartGroup": "ZenChartArsenal",
            "dictName": "AngelaIconMultiR1C",
            "typ": "AngelaIconMultiR1C"
        },
        {
            "img": "A008.png",
            "template": "A008",
            "chartGroup": "ZenChartArsenal",
            "dictName": "AngelaIconMultiR2C",
            "typ": "AngelaIconMultiR2C"
        },
        {
            "img": "A011.png",
            "template": "A011",
            "chartGroup": "ZenChartArsenal",
            "dictName": "Angela1C_MultiRowOneLineHeader",
            "typ": "Angela1C"
        },
        {
            "img": "A012.png",
            "template": "A012",
            "chartGroup": "ZenChartArsenal",
            "dictName": "Angela1C_MultiRowTwoLineHeader",
            "typ": "Angela1C"
        },
        // {
        //     "img": "C001.png",
        //     "template": "C001",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "GaugeVBarB",
        //     "typ": "ZenVerBarChart"
        // },
        // {
        //     "img": "C002.png",
        //     "template": "C002",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "GaugeVBarG",
        //     "typ": "ZenGauge"
        // },
        // {
        //     "img": "C003.png",
        //     "template": "C003",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "GtCostGauge",
        //     "typ": "ZenGauge"
        // },
        // {
        //     "img": "C004.png",
        //     "template": "C004",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "GtHorCostContributor",
        //     "typ": "ZenHorBarChart"
        // },
        // {
        //     "img": "C005.png",
        //     "template": "C005",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "ZenVerBarAndTrend",
        //     "typ": "ZenVerBarChart"
        // },
        // {
        //     "img": "C006.png",
        //     "template": "C006",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "SnippetLineZenDonutTimeDistribution",
        //     "typ": "ZenDonut"
        // },
        // {
        //     "img": "C007.png",
        //     "template": "C007",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "SnippetLineZenGaugeAPQ",
        //     "typ": "ZenGauge"
        // },
        // {
        //     "img": "C007.png",
        //     "template": "C007",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "SnippetLineZenGaugeAPQ_1",
        //     "typ": "ZenGauge"
        // },
        // {
        //     "img": "C007.png",
        //     "template": "C007",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "SnippetLineZenGaugeAPQ_2",
        //     "typ": "ZenGauge"
        // },
        // {
        //     "img": "C007.png",
        //     "template": "C007",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "SnippetLineZenGaugeAPQ_3",
        //     "typ": "ZenGauge"
        // },
        // {
        //     "img": "C008.png",
        //     "template": "C008",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "SnippetLineZenGaugeOEE",
        //     "typ": "ZenGauge"
        // },
        // {
        //     "img": "C009.png",
        //     "template": "C009",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "SnippetLineZenGaugeSingle",
        //     "typ": "ZenGauge"
        // },
        // {
        //     "img": "C010.png",
        //     "template": "C010",
        //     "chartGroup": "ZenChartArsenal",
        //     "dictName": "SnippetLineZenVerBarChartHourlyOEE",
        //     "typ": "ZenVerBarChart"
        // },
        {
            "img": "C011.png",
            "template": "C011",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenClusterColHor",
            "typ": "ZenClusterColHor"
        },
        {
            "img": "C012.png",
            "template": "C012",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenClusterColVer",
            "typ": "ZenClusterColVer"
        },
        {
            "img": "C013.png",
            "template": "C013",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenDonut",
            "typ": "ZenDonut"
        },
        {
            "img": "C014.png",
            "template": "C014",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenGanttChart",
            "typ": "ZenGanttChart"
        },
        {
            "img": "C015.png",
            "template": "C015",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenGauge",
            "typ": "ZenGauge"
        },
        {
            "img": "C016.png",
            "template": "C016",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenGoldenTunnel",
            "typ": "ZenGoldenTunnel"
        },
        {
            "img": "C017.png",
            "template": "C017",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenHorBarChart",
            "typ": "ZenHorBarChart"
        },
        {
            "img": "C018.png",
            "template": "C018",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenHorCandleStick",
            "typ": "ZenHorCandleStick"
        },
        {
            "img": "C019.png",
            "template": "C019",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenHorStackBar",
            "typ": "ZenHorStackBar"
        },
        {
            "img": "C020.png",
            "template": "C020",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenPareto",
            "typ": "ZenPareto"
        },
        {
            "img": "C021.png",
            "template": "C021",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenPieBar",
            "typ": "ZenPieBar"
        },
        {
            "img": "C022.png",
            "template": "C022",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenRadar",
            "typ": "ZenRadar"
        },
        {
            "img": "C023.png",
            "template": "C023",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenSpectrum",
            "typ": "ZenSpectrum"
        },
        {
            "img": "C024.png",
            "template": "C024",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenStackedNePo",
            "typ": "ZenStackedNePo"
        },
        {
            "img": "C025.png",
            "template": "C025",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenVerBarChart25",
            "typ": "ZenVerBarChart"
        },
        {
            "img": "C027.png",
            "template": "C027",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenVerCandleStick",
            "typ": "ZenVerCandleStick"
        },
        {
            "img": "C028.png",
            "template": "C028",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenVerStackBar",
            "typ": "ZenVerStackBar"
        },
        {
            "img": "C029.png",
            "template": "C029",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenWaterfallChart",
            "typ": "ZenWaterfallChart"
        },
        {
            "img": "C030.png",
            "template": "C030",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenGaugeMultiColor",
            "typ": "ZenGaugeMultiColor"
        },
        {
            "img": "C031.png",
            "template": "C031",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenVerBarChartMultiColorGreen",
            "typ": "ZenVerBarChart"
        },
        {
            "img": "C032.png",
            "template": "C032",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenVerBarChartMultiColorRed",
            "typ": "ZenVerBarChart"
        },
        {
            "img": "C033.png",
            "template": "C033",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenVerBarChart33",
            "typ": "ZenVerBarChart"
        },
        {
            "img": "C040.png",
            "template": "C040",
            "chartGroup": "ZenChartArsenal",
            "dictName": "ZenVerBarChart40",
            "typ": "ZenVerBarChart"
        },
        {
            "img": "stable.png",
            "template": "stable",
            "chartGroup": "ZenChartArsenal",
            "dictName": "Stable",
            "typ": "stable"
        },
        {
            "img": "image.png",
            "template": "image",
            "chartGroup": "ZenChartArsenal",
            "dictName": "Image",
            "typ": "image"
        },
        {
            "img": "label.png",
            "template": "label",
            "chartGroup": "ZenChartArsenal",
            "dictName": "Label",
            "typ": "label"
        },
        {
            "img": "route.png",
            "template": "route",
            "chartGroup": "ZenChartArsenal",
            "dictName": "Route",
            "typ": "route"
        },
        {
            "img": "emptyColumn.png",
            "template": "emptyColumn"
        }
    ];
    const urlCode = useSelector(state => state.urlCode);
    const [modalTitle, setModalTitle] = useState('');
    const [smodalForm] = Form.useForm();
    const [dictForm] = Form.useForm();
    const [pageConfigData, setPageConfigData] = useState();
    const [imgModal, setImgModal] = useState({
        open: false,
        img: null
    });
    const [smodalLoading, setSmodalLoading] = useState(false);
    const [selectedImg, setSelectedImg] = useState('');
    const [modalData, setModalData] = useState({
        open: false,
        typ: '',
        data: null,
        loading: false
    });

    const toggleModal = ({ open = false, typ = '', data = null, loading = false }) => {
        setModalData({ typ, open, data, loading });
    }

    const cloneDashboard = () => {
        liracrypt.post('/test', { _id: pageConfigData._id, dictName: pageConfigData?.dictName })
            .then(({ data }) => {
                if (data.isSuccess) {
                    console.log(data);
                    message.success(data.message || 'Successfully Cloned');
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
            })
    }
    const addCol = () => {
        let pageData = { ...pageConfigData };
        pageData.config.chartElement.push({
            colSize: 12,
            chartList: [],
            style: {}
        })
        setPageConfigData(pageData);
        message.success('New Row Added');
    };

    const closeModal = () => {
        setSelectedImg(null);
        toggleModal({
            open: true,
            typ: '',
            loading: true,
            data: null
        });
        setTimeout(() => {
            toggleModal({});
        }, 20)
    }

    const handleDrop = (e, rowIndex) => {
        e.nativeEvent.preventDefault()
        if (!e) return;
        const files = e.nativeEvent.dataTransfer.files;
        if (!files[0]) return;
        if (files[0].type.includes('image/')) {
            toggleModal({
                open: true,
                loading: false,
                data: {
                    rowIndex
                },
                typ: 'add-chart'
            })
            // console.log(files[0]);
        } else {
            notification.error({ message: 'Please Select image file only' })
        }
    };

    const saveChart = ({ chartConfig, resolve = () => { } }) => {
        liracrypt.patch('/chart/builder', { ...chartConfig, _id: chartConfig._id })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setSmodalLoading(false);
                    if (modalData.open) {
                        closeModal();
                    }
                    dictForm.submit();
                    resolve();
                }
            }).catch(err => {
                ApiErrorComp();
                console.log(err);
            })
    }

    const editChart = (values) => {
        setSmodalLoading(true);
        let pageData = { ...pageConfigData };
        let _rowList = [...pageData.config.chartElement];
        let selectedRow = { ..._rowList[modalData.data.rowIndex] };
        let selectedChart = { ...selectedRow.chartList[modalData.data.chartIndex] };
        let chartLayout = { ...modalData.data.chartData.chartLayout, ...values };
        selectedChart = { ...modalData.data.chartData, chartLayout };
        selectedRow.chartList[modalData.data.chartIndex] = selectedChart;
        _rowList[modalData.data.rowIndex] = selectedRow;
        pageData.config.chartElement = _rowList;
        saveChart({ chartConfig: pageData });
    }

    const deleteChart = (chartIndex, rowIndex) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this chart?',
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: { danger: true },
            onOk: () => {
                return new Promise((resolve, reject) => {
                    setSmodalLoading(true);
                    let pageData = { ...pageConfigData };
                    let _rowList = [...pageData.config.chartElement];
                    let selectedRow = { ..._rowList[rowIndex] };
                    selectedRow.chartList = selectedRow.chartList.filter((x, i) => i !== chartIndex);
                    _rowList[rowIndex] = selectedRow;
                    pageData.config.chartElement = _rowList;
                    saveChart({ chartConfig: pageData, resolve: resolve });
                })
            }
        })
    }

    const onChartAdd = (values) => {
        // setSmodalLoading(true);
        let pageData = { ...pageConfigData };
        let _rowList = [...pageData.config.chartElement];
        let chartRow = { ..._rowList[modalData.data.rowIndex] };
        let selectedChart = chartTemplate.find(x => x.template === selectedImg);
        delete selectedChart.img;
        let chartLayout = { ...selectedChart, ...values };
        if (selectedChart.template === 'emptyColumn') {
            chartRow.chartList.push({
                chartLayout, style: {
                    border: "1px solid #3c3e4f",
                    borderRadius: "10px"
                }, chartList: []
            });
        } else {
            chartRow.chartList.push({
                chartLayout, style:
                {
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "2px 2px 2px 2px",

                }, typ: selectedChart.typ
            });
        }
        _rowList[modalData.data.rowIndex] = chartRow;
        pageData.config.chartElement = _rowList;
        saveChart({ chartConfig: pageData });
    };

    const onJsonUpload = (values) => {
        setSmodalLoading(true);
        let formData = new FormData();
        formData.append('dictName', pageConfigData?.dictName);
        formData.append('_id', pageConfigData?._id);
        Object.keys(values).forEach(x => {
            formData.append(x, values[x]);
        });
        let dictFormData = dictForm.getFieldsValue();
        Object.keys(dictFormData).forEach(x => {
            formData.append(x, dictFormData[x]);
        });
        liracrypt.uploadFile('/chartconfig/upload', formData)
            .then(({ data }) => {
                console.log(data);
                setSmodalLoading(false);
                if (data.isSuccess) {
                    dictForm.submit();
                    closeModal();
                    //    message.success(data.message || 'Successfully Saved');
                } else {
                    message.success(data.message || 'Something went wrong');
                }
            }).catch(err => {
                setSmodalLoading(false);
                console.log(err);
                message.error('Something went wrong');
            })
    }

    const downloadJson = () => {
        liracrypt.post('/chartconfig/download', { dictName: pageConfigData?.dictName, _id: pageConfigData?._id }).then(({ data }) => {
            if (data.isSuccess) {
                window.open(
                    `${process.env.REACT_APP_API_ENDPOINT}/fetchfilesingleattachmentzenform?filePath=${data.data.filePath}&fileName=${data.data.fileName}&token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
                    '_blank'
                )
            } else {
                message.error(data.message);
            }
        })
    };

    const editRow = (values) => {
        setSmodalLoading(true);
        let pageData = { ...pageConfigData };
        let _rowList = [...pageData.config.chartElement];
        let selectedRow = { ..._rowList[modalData.data.rowIndex] };
        selectedRow = { ...selectedRow, ...values };
        _rowList[modalData.data.rowIndex] = selectedRow;
        pageData.config.chartElement = _rowList;
        saveChart({ chartConfig: pageData });
    }

    const deleteColumn = (rowIndex) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this entire column?',
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: { danger: true },
            onOk: () => {
                return new Promise((resolve, reject) => {
                    setSmodalLoading(true);
                    let pageData = { ...pageConfigData };
                    pageData.config.chartElement = pageData.config.chartElement.filter((_, i) => i !== rowIndex);
                    saveChart({ chartConfig: pageData, resolve });
                })
            }
        })
    }

    const onSmodalSubmit = (values) => {
        if (modalData.typ === 'add-chart') {
            onChartAdd(values);
            return;
        };
        if (modalData.typ === 'edit-chart') {
            editChart(values);
            return;
        };
        if (modalData.typ === 'upload-json') {
            onJsonUpload(values);
        }

        if (modalData.typ === 'edit-row') {
            editRow(values);
        }
    }

    return (
        <div>
            <div className='phantom-form'>
                <StAddNew
                    initForm={dictForm}
                    colSpan={12}
                    stopResetForm={true}
                    urlEndpoint="/miscellaneous/pageconfig"
                    urlData={{ dictName: "ChartBuilderQuery" }}
                    extraData={{}}
                    onCallFinish={({ data }) => {
                        setPageConfigData(data.data);
                    }}
                />
            </div>
            {
                pageConfigData && (
                    <div className='chart-builder-container'>
                        <div className="sticky-header">
                            <div style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
                                {
                                    chartTemplate.map((ct, imgIndex) => {
                                        try {
                                            let image = require(`../assets/static/chartImage/${ct.img}`);
                                            ct.img = image;
                                        } catch (err) {
                                            ct.img = require(`../assets/static/noImg.jpeg`);
                                        }
                                        return (
                                            <div style={{ alignItems: 'center', display: 'flex', marginRight: 5 }}>
                                                <div key={imgIndex} style={{ cursor: 'pointer' }}>
                                                    <img
                                                        title={`${ct.dictName}-${ct.template}`}
                                                        onClick={() => setImgModal({
                                                            open: true,
                                                            img: ct.img
                                                        })} onDragEnd={() => setSelectedImg(ct.template)} style={{ width: '60px', height: 'auto' }} src={ct.img} />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={{ marginTop: 10 }}>
                                <Button ghost style={{ marginRight: 20 }} type="primary" onClick={addCol}>Add New Column</Button>
                                <Button ghost style={{ marginRight: 20 }} type="primary" onClick={downloadJson}>
                                    Download JSON
                                </Button>
                                <Button ghost style={{ marginRight: 20 }} type="primary" onClick={() => {
                                    toggleModal({
                                        open: true,
                                        typ: 'upload-json'
                                    })
                                }}>
                                    Upload JSON
                                </Button>
                                <Button ghost style={{ marginRight: 20 }} type="primary" onClick={cloneDashboard}>
                                    Clone Dashboard
                                </Button>
                                <a className='ant-btn ant-btn-primary ant-btn-background-ghost' target='_blank' href={`/v02/${localStorage.getItem('urlCode')}/dc?dn=${pageConfigData?.dictName}`}>
                                    Preview Dashboard
                                </a>
                            </div>
                        </div>
                        <Row>
                            {
                                pageConfigData?.config?.chartElement.map((x, i) => (
                                    <Col key={`row-${i}`} span={x.colSize}>
                                        <div className='chart-upload-header'>
                                            <h1 style={{ color: 'white', fontSize: 15 }}>Drop Chart Here</h1>
                                            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                <Tooltip title={'Edit Column'} color="blue">
                                                    <Button
                                                        type="link"
                                                        onClick={() => {
                                                            toggleModal({
                                                                typ: 'edit-row',
                                                                data: { ...x, rowIndex: i },
                                                                open: true,
                                                                loading: false
                                                            })
                                                        }}
                                                        style={{ marginRight: 10 }}
                                                        icon={
                                                            <EditOutlined style={{ fontSize: 30 }} />
                                                        }>{''}</Button>
                                                </Tooltip>
                                                <Tooltip title={'Delete Column'} color="red">
                                                    <Button
                                                        type="link"
                                                        danger
                                                        onClick={() => {
                                                            deleteColumn(i)
                                                        }}
                                                        style={{ marginRight: 10 }}
                                                        icon={
                                                            <DeleteOutlined style={{ fontSize: 30 }} />
                                                        }>{''}</Button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div style={{ minHeight: '40px', border: '1px solid grey' }} onDragOver={e => e.preventDefault()} onDrop={(e) => handleDrop(e, i)}>
                                            <Row>
                                                {
                                                    x.chartList.map((chart, chartIndex) => (
                                                        <Col span={chart.chartLayout.colSize} key={`childChart-${chartIndex}`} style={{ overflow: 'hidden' }}>
                                                            <div className='zen-preview-control-wrapper'>
                                                                <img style={{ width: `${chart.chartLayout.width}%`, height: parseInt(chart.chartLayout.height), margin: 5 }} src={require(`../assets/static/chartImage/${chart.chartLayout.template}.png`)} />
                                                                <div className='control-edit-btns' style={{ display: 'flex', background: '#000000' }}>
                                                                    <Tooltip title={'Edit Chart Config'} color="blue">
                                                                        <Button
                                                                            type="link"
                                                                            onClick={() => {
                                                                                toggleModal({
                                                                                    typ: 'edit-chart',
                                                                                    data: { ...chart.chartLayout, chartData: { ...chart }, chartIndex, rowIndex: i },
                                                                                    open: true,
                                                                                    loading: false
                                                                                })
                                                                            }}
                                                                            style={{ marginRight: 10 }}
                                                                            icon={
                                                                                <EditOutlined style={{ fontSize: 30 }} />
                                                                            }>{''}</Button>
                                                                    </Tooltip>
                                                                    <Tooltip title={'Delete Chart'} color="red">
                                                                        <Button
                                                                            onClick={() => deleteChart(chartIndex, i)}
                                                                            type="link"
                                                                            danger={true}
                                                                            icon={
                                                                                <DeleteOutlined style={{ fontSize: 30 }} />
                                                                            }>{''}</Button>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))
                                                }
                                            </Row>
                                        </div>
                                    </Col>
                                ))
                            }
                        </Row>
                        <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={modalData.open} title={modalTitle || "Add Zen Form Control"} onCancel={closeModal}>
                            {
                                modalData.loading ?
                                    <></> :
                                    <>
                                        <StAddNew
                                            urlMethod={modalData.typ !== 'upload-json' ? "POST" : undefined}
                                            formName="ChartBuilderForm"
                                            setSmodalTitle={title => { setModalTitle(title) }}
                                            initForm={smodalForm}
                                            colSpan={24}
                                            urlEndpoint={modalData.typ === 'upload-json' ? '/smodal' : '/smodal/zenform'}
                                            urlData={{
                                                ...modalData.data,
                                                dictName: dictNames[modalData.typ]
                                            }}
                                            onFormSubmit={onSmodalSubmit}
                                        />
                                        <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                            <Button loading={smodalLoading} htmlType='submit' type="primary" form={'ChartBuilderForm'}>Submit</Button>
                                        </div>
                                    </>
                            }
                        </Modal>

                        <Modal title={"Chart Image"} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} open={imgModal.open} onCancel={() => setImgModal({
                            open: false,
                            img: null
                        })}>
                            {
                                imgModal.img && (
                                    <div style={{ margin: 'auto', display: 'block' }}>
                                        <img style={{ width: '100%', height: 'auto', margin: 'auto', display: 'block' }} src={imgModal.img} alt="chartImage" />
                                    </div>
                                )
                            }
                        </Modal>
                    </div>
                )
            }
        </div>

    )
};

export default ChartBuilder;